// Cliente del chat de Arcana. Toda la inteligencia (contexto + DeepSeek)
// vive en /api/chat — el browser solo manda historial y recibe respuesta.

import axios from 'axios';
import { getToken } from './authService';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';

const client = axios.create({
  baseURL: API_BASE,
  timeout: 600000,
});

client.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/**
 * Envía la conversación completa al endpoint server-side.
 * @param {Array<{role:'user'|'assistant', content:string}>} messages
 * @returns {Promise<{ answer:string, context_summary:object }>}
 */
export async function sendChat(messages) {
  const { data } = await client.post('/chat', { messages });
  return data;
}

const chatService = { sendChat };
export default chatService;
